import React, { useState } from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    FormControlLabel,
Radio,
    FormControl,
    FormLabel,
    RadioGroup,
    Button,
    Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import RobotFileTempletPopUp from "./RobotFileTempletPopUp";



function KeywordDesignPopup({ open, handleClose, framework }) {
    const navigate = useNavigate();
    const [selectedValue, setSelectedValue] = useState("");
     // For navigating to the landing page
     
    const [showPopup, setShowPopup] = useState(false);

    
    const handleClosePopup = () => {
        setShowPopup(false);
      };

    // Function to navigate to the landing page
    const handleNavigate = () => {
        //navigate("/dashboard/test-automation/robot-framework");
        if (selectedValue === "New_Project") {
            navigate("/dashboard/test-automation/robot-framework", { state: { framework: framework } } );
        }
        else if (selectedValue === "New_User_Story") {
            navigate("/dashboard/test-automation/robot-framework", { state: { framework: framework } });
        }
        else if (selectedValue === "Existing_User_Story", { state: { framework: framework } }) {
            setShowPopup(true);

           
        }
    };
    
   

  


    return (
        <>
            <Dialog
                open={open}
             //   onClose={handleClose}
                PaperProps={{
                    sx: {
                        borderRadius: "8px",
                        minWidth: "400px",
                        padding: "20px",
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        //   fontWeight: "bold",
                        fontSize: "16px",
                        paddingBottom: "10px",
                        fontFamily: "Roboto, sans-serif",
                        marginBottom: '10px'
                    }}
                >
                    Select Flow
                    <IconButton
                                onClick={handleClose} // Close dialog when clicked
                                sx={{
                                  position: "absolute", // Position the close button absolutely
                                  top: "8px", // Adjust distance from top
                                  right: "8px", // Adjust distance from right
                                }}
                              >
                                <CloseIcon />
                              </IconButton>
                </DialogTitle>

                <DialogContent sx={{ paddingBottom: "20px" }}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Choose one option</FormLabel>
                        <RadioGroup
                            aria-label="options"
                            name="radio-buttons-group"
                            value={selectedValue}
                            onChange={(e) => setSelectedValue(e.target.value)}
                        >
                            <FormControlLabel value="New_Project" control={<Radio />} label="New Project" />
                            <FormControlLabel value="New_User_Story" control={<Radio />} label="Existing Project for New User Story/FSD" />
                            <FormControlLabel value="Existing_User_Story" control={<Radio />} label="Existing Project for Existing User Story/FSD" />
                        </RadioGroup>
                    </FormControl>
                </DialogContent>

                <Divider />

                <DialogActions sx={{ justifyContent: "flex-end", padding: "10px 24px" }}>
                  
                    <Button
                        onClick={handleNavigate} // Use onClose prop to close the dialog
                        sx={{
                            textTransform: "none",
                            // fontWeight: "bold",
                            fontSize: "16px",
                            fontFamily: "Roboto, sans-serif",
                            color: "#49A3FF", // Blue text by default
                            // border: "1px solid #1976d2", // Blue border
                            backgroundColor: "white", // White background
                            "&:hover": {
                                backgroundColor: "#49A3FF", // Blue background on hover
                                color: "white", // White text on hover
                            },
                            "&:active": {
                                backgroundColor: "#49A3FF", // Darker blue when clicked
                                color: "white",
                            },
                            display: "flex",
                            alignItems: "center",
                            padding: "5px 15px",
                        }}
                    >
                        Confirm
                    </Button>

                   
                </DialogActions>
            </Dialog>
            <RobotFileTempletPopUp open={showPopup}  handleClose={handleClosePopup} framework={"robot-framework"} />

        </>
    );
}

export default KeywordDesignPopup;
